import React from 'react'

export default function Datatable() {
  return (
    <div>hi chellom</div>
  )
}
